var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, Delete, InsertLinkOutlined, MoreVert, Upload } from "@mui/icons-material";
import { Box, Chip, Stack, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { faintblue } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
// import {   ShareIcon } from "../../spareIssue/assets";
import { getstockTransferRequisition } from "../../stockTransferRequistion/apiCall";
import { StockTransferRequisitionAPIKeys } from "../../stockTransferRequistion/entity";
import { deliveryLocationGet, supplierListWPOGet, WorkPurchaseOrderByJobcardNoAPI, workPurchaseOrderCreate, WPOOrganizationModulesItemSettingAPI } from "../apiCall";
// import {  UploadFileSvg } from "../assets/assets";
import MultipleJCWPOPartDetails from "../components/mulitipleJCPartDetailsWPO";
import WPOPartDetails from "../components/partDetailsWPO";
import { WorkPurchaseOrderKeys } from "../entity";
import { DownloadIcon, PrintIcon, ShareIcon } from "../../../assets/images";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { ExportIconSVG } from "../../../assets/customIcons";
import { secondary } from "../../../theme/colors";
var tabs = [{
        id: "0",
        label: "General & part detail"
    }, {
        id: "1",
        label: "Work order data"
    }, {
        id: "2",
        label: "Additional information"
    }];
export var CreateWorkPurchaseOrder = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$WorkPurchaseOrd, _crud$WorkPurchaseOrd2, _crud$WorkPurchaseOrd3, _crud$WorkPurchaseOrd4;
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var isDisable = false;
    var dispatch = useAppDispatch();
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get("mode");
    var id = useParams().id;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    console.log("WPOOrganizationModulesItemSetting", ((_crud$WorkPurchaseOrd = crud[WorkPurchaseOrderKeys.WPOOrganizationModulesItemSetting]) === null || _crud$WorkPurchaseOrd === void 0 || (_crud$WorkPurchaseOrd = _crud$WorkPurchaseOrd.data) === null || _crud$WorkPurchaseOrd === void 0 ? void 0 : _crud$WorkPurchaseOrd.WPOType) !== "Single JobCard");
    useEffect(function () {
        getWPOConfiguration();
    }, []);
    var getWPOConfiguration = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        WPOType: "WorkPurchaseOrder"
                    };
                    return [4 /*yield*/, WPOOrganizationModulesItemSettingAPI({
                            key: WorkPurchaseOrderKeys.WPOOrganizationModulesItemSetting,
                            request: request
                        })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var supplierListWPO = function (params) { return supplierListWPOGet(_objectSpread(_objectSpread({}, params), {}, {
        // request: {
        //   ...params.request,
        //   OrganizationId: UserOrganization,
        //   ParentOrganizationId: UserParentOrganization
        // }
        request: {
            id: "f47a568a-7107-4520-9aa8-235296114b81",
            // temp
            ParentOrganizationId: "04945692-d924-4f9d-ae24-83b46eeb5867"
        }
    })); };
    var jobCardListAPI = function (params) { return WorkPurchaseOrderByJobcardNoAPI(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            OrganizationId: UserOrganization,
            ParentOrganizationId: UserParentOrganization
        })
    })); };
    var deliveryLocationList = function (params) { return deliveryLocationGet(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            OrganizationId: UserOrganization
        })
    })); };
    var workOrderDetailsTabElements = [{
            type: FormItemTypes.CardComponent,
            name: 'orderDetails',
            label: undefined,
            value: null,
            md: 6,
            columnSize: 12,
            sx: {
                bgcolor: secondary[50],
                padding: '12px 16px'
            },
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Status',
                            columnSize: true
                        }, {
                            type: FormItemTypes.Chip,
                            name: '',
                            label: 'Active',
                            variant: 'filled',
                            color: 'info',
                            columnSize: 0,
                            sx: {
                                borderRadius: '8px',
                                padding: '2px 8px',
                                fontSize: 'sm',
                                fontWeight: 'medium'
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Created By :',
                            value: null,
                            columnSize: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedBy',
                            value: null,
                            columnSize: 0,
                            fontWeight: 'normal',
                            fontSize: 'sm'
                        }]
                }]
        }, {
            type: FormItemTypes.SearchSelect,
            name: 'UOM',
            label: 'UOM',
            options: [{
                    id: 'g',
                    Name: 'g'
                }, {
                    id: 'ml',
                    Name: 'ml'
                }],
            value: null,
            required: true
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Rate',
            label: 'Rate(₹) ',
            value: null,
            xs: 6
        }, {
            type: FormItemTypes.TextInput,
            name: 'Quantity',
            label: 'Quantity',
            value: null,
            xs: 6
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Taxes',
            label: 'Taxes(₹)',
            value: null,
            xs: 8
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Taxes',
            label: 'Taxes(%)',
            value: null,
            xs: 4
        }, {
            type: FormItemTypes.NumberInput,
            name: 'discount',
            label: 'Discount (₹)',
            value: null,
            xs: 8
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Doscount',
            label: 'Discount (%)',
            value: null,
            xs: 4
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Total',
            label: 'Total amount (₹)',
            value: null,
            xs: 12
        }, {
            type: FormItemTypes.TextInput,
            name: 'Remarks',
            label: 'Remarks',
            value: null,
            xs: 12
        }];
    var muiltipleJCWorkOrderDetailsElements = [{
            type: FormItemTypes.CardComponent,
            name: 'orderDetails',
            label: undefined,
            value: null,
            md: 6,
            columnSize: 12,
            sx: {
                bgcolor: secondary[50],
                padding: '12px 16px'
            },
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Status',
                            columnSize: true
                        }, {
                            type: FormItemTypes.Chip,
                            name: '',
                            label: 'Active',
                            variant: 'filled',
                            color: 'info',
                            columnSize: 0,
                            sx: {
                                borderRadius: '8px',
                                padding: '2px 8px',
                                fontSize: 'sm',
                                fontWeight: 'medium'
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Created By :',
                            value: null,
                            columnSize: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedBy',
                            value: null,
                            columnSize: 0,
                            fontWeight: 'normal',
                            fontSize: 'sm'
                        }]
                }]
        }, {
            type: FormItemTypes.SingleSelect,
            name: 'service name',
            label: 'Service name',
            placeholder: 'Select',
            value: null,
            required: true
        }, {
            type: FormItemTypes.SingleSelect,
            name: 'VIN',
            label: 'VIN reference',
            placeholder: 'Select',
            value: null,
            required: true
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Odometer_Reading',
            label: 'Odometer reading',
            value: null,
            required: true
        }, {
            type: FormItemTypes.SearchSelect,
            name: 'UOM',
            label: 'UOM',
            options: [{
                    id: 'g',
                    Name: 'g'
                }, {
                    id: 'ml',
                    Name: 'ml'
                }],
            value: null,
            required: true
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Rate',
            label: 'Rate(₹) ',
            value: null,
            xs: 6
        }, {
            type: FormItemTypes.TextInput,
            name: 'Quantity',
            label: 'Quantity',
            value: null,
            xs: 6
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Taxes',
            label: 'Taxes(₹)',
            value: null,
            xs: 8
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Taxes',
            label: 'Taxes(%)',
            value: null,
            xs: 4
        }, {
            type: FormItemTypes.NumberInput,
            name: 'discount',
            label: 'Discount (₹)',
            value: null,
            xs: 8
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Doscount',
            label: 'Discount (%)',
            value: null,
            xs: 4
        }, {
            type: FormItemTypes.NumberInput,
            name: 'Total',
            label: 'Total amount (₹)',
            value: null,
            xs: 12
        }, {
            type: FormItemTypes.TextInput,
            name: 'Remarks',
            label: 'Remarks',
            value: null,
            xs: 12
        }];
    var step1 = [{
            type: FormItemTypes.CardComponent,
            name: "",
            columnSize: 12,
            title: "Basic Details",
            sx: {
                borderRadius: '8px !important',
                padding: 1.5,
                '& .MuiCardHeader-root': {
                    padding: '0px 0px 20px 0px !important'
                },
                '& .MuiCardContent-root': {
                    padding: 0
                }
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    justifyContent: "end",
                    columnSize: 12,
                    elements: ((_crud$WorkPurchaseOrd2 = crud[WorkPurchaseOrderKeys.WPOOrganizationModulesItemSetting]) === null || _crud$WorkPurchaseOrd2 === void 0 || (_crud$WorkPurchaseOrd2 = _crud$WorkPurchaseOrd2.data) === null || _crud$WorkPurchaseOrd2 === void 0 ? void 0 : _crud$WorkPurchaseOrd2.WPOType) === "Single JobCard" ? [{
                            type: FormItemTypes.SearchSelect,
                            placeholder: 'Search work purchase order',
                            value: null,
                            valueExpr: "id",
                            displayExpr: "JobCardNo",
                            required: true,
                            getListData: jobCardListAPI,
                            setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            VIN: currValue.VinNo,
                                            TechnicianId: currValue.TechnicianId,
                                            TechnicianName: currValue.TechnicianName,
                                            OdometerReading: currValue.ODOMeterReading,
                                            JobCardId: currValue.JobCardId,
                                            JobCardNo: currValue.JobCardNo
                                        }];
                                });
                            }); },
                            name: "SearchWithOptions",
                            label: "Job card"
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "VIN",
                            label: "VIN",
                            placeholder: "VIN No.",
                            disabled: true
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "TechnicianName",
                            label: "Technician",
                            placeholder: "Technician",
                            required: true,
                            disabled: true
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "OdometerReading",
                            label: "Odometer",
                            placeholder: "Odometer Reading",
                            disabled: true
                        }] : []
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "SupplierId",
                    label: "Supplier",
                    value: null,
                    getListData: supplierListWPO,
                    setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {
                                    SupplierName: currValue.Name
                                }];
                        });
                    }); },
                    required: true
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "OrderDate",
                    label: "Order date",
                    value: null,
                    xs: 6,
                    sm: 6,
                    md: 3,
                    required: true
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedDeliveryDate",
                    label: "Expected delivery date",
                    value: null,
                    xs: 6,
                    sm: 6,
                    md: 3,
                    required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "DeliveryLocationId",
                    label: "Delivery location",
                    value: null,
                    getListData: deliveryLocationList,
                    displayExpr: 'Address1'
                }]
        }];
    var isSingleJobCard = ((_crud$WorkPurchaseOrd3 = crud[WorkPurchaseOrderKeys.WPOOrganizationModulesItemSetting]) === null || _crud$WorkPurchaseOrd3 === void 0 || (_crud$WorkPurchaseOrd3 = _crud$WorkPurchaseOrd3.data) === null || _crud$WorkPurchaseOrd3 === void 0 ? void 0 : _crud$WorkPurchaseOrd3.WPOType) === "Single JobCard";
    var step2 = [isSingleJobCard && isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'singleJobCard',
            label: '',
            value: null,
            sx: {
                padding: 0
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'orderDetails',
                    value: 'Work order data',
                    fontWeight: 'strong',
                    sx: {
                        flexBasis: 'auto !important',
                        whiteSpace: 'nowrap'
                    },
                    columnSize: 0
                }, {
                    type: FormItemTypes.Chip,
                    name: '',
                    value: '2',
                    variant: 'outlined',
                    size: 'small',
                    color: 'primary',
                    sx: {
                        ml: 2
                    }
                }],
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'wpo',
                    freeSolo: true,
                    multiple: true,
                    disableCloseOnSelect: true,
                    renderTags: function () { return null; },
                    clearText: 'Clear Selected Labour',
                    columnSize: true,
                    placeholder: 'Search part name code...'
                }, {
                    type: FormItemTypes.Button,
                    name: 'More',
                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                    size: 'small',
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: '7px'
                    },
                    columnSize: 0,
                    setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                        var action, PartDetailsMobile, _PartDetailsMobile;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        containerProps: {
                                            anchorEl: e.target.parentElement
                                        },
                                        Component: ActionMenuList,
                                        componentProps: {
                                            items: [{
                                                    id: 'delete',
                                                    children: [/*#__PURE__*/ React.createElement(Delete, {
                                                            color: "secondary",
                                                            fontSize: "small"
                                                        }), "Delete"]
                                                }, {
                                                    id: 'upload',
                                                    children: [/*#__PURE__*/ React.createElement(Upload, {
                                                            color: "secondary",
                                                            fontSize: "small"
                                                        }), "Upload"]
                                                }, {
                                                    id: 'export',
                                                    children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ExportIconSVG, {
                                                        fontSize: "small"
                                                    }), " Export ")
                                                }]
                                        }
                                    }))];
                                case 1:
                                    action = _a.sent();
                                    PartDetailsMobile = state === null || state === void 0 ? void 0 : state.PartDetailsMobile;
                                    if ((action === null || action === void 0 ? void 0 : action.payload) === 'delete') {
                                        PartDetailsMobile = (_PartDetailsMobile = PartDetailsMobile) === null || _PartDetailsMobile === void 0 ? void 0 : _PartDetailsMobile.filter(function (p) { return !p.Selected; });
                                    }
                                    return [2 /*return*/, {
                                            PartDetailsMobile: PartDetailsMobile
                                        }];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.List,
                    name: 'data',
                    columnSize: 12,
                    value: [{
                            id: 0,
                            Name: "Break pad 01",
                            code: '#01100320',
                            CreatedBy: 'Michael Adams'
                        }, {
                            id: 1,
                            Name: "Break pad 02",
                            code: '#01100320',
                            CreatedBy: 'Michael Adams'
                        }, {
                            id: 2,
                            Name: "Radiator small CN",
                            code: '#01100320',
                            CreatedBy: 'Michael Adams'
                        }, {
                            id: 3,
                            Name: "Break pad 03",
                            code: '#01100320',
                            CreatedBy: 'Michael Adams'
                        }],
                    columns: [{
                            field: 'singleJobCard',
                            flex: 1,
                            renderCell: function (_ref) {
                                var row = _ref.row;
                                console.log('json', row);
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    height: '100%',
                                    paddingTop: '9px'
                                }, /*#__PURE__*/ React.createElement(Stack, {
                                    direction: 'column',
                                    width: '100%',
                                    justifyContent: 'center'
                                }, /*#__PURE__*/ React.createElement(Stack, {
                                    justifyContent: 'space-between',
                                    direction: 'row'
                                }, /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        wordWrap: 'break-word',
                                        overflowWrap: 'break-word',
                                        whiteSpace: 'normal',
                                        overflow: 'hidden',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical'
                                    },
                                    fontWeight: 'medium'
                                }, row.Name), /*#__PURE__*/ React.createElement(Chip, {
                                    size: "small",
                                    variant: "filled",
                                    color: "info",
                                    label: "P"
                                })), /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h6",
                                    color: "secondary"
                                }, row.code))));
                            }
                        }],
                    elements: workOrderDetailsTabElements
                }],
            columnSize: 12
        } : !isSingleJobCard && isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'multiple',
            label: '',
            value: null,
            sx: {
                padding: 0
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'orderDetails',
                    value: 'Work order data',
                    fontWeight: 'strong',
                    sx: {
                        flexBasis: 'auto !important',
                        whiteSpace: 'nowrap'
                    },
                    columnSize: 0
                }, {
                    type: FormItemTypes.Chip,
                    name: '',
                    value: '2',
                    variant: 'outlined',
                    size: 'small',
                    color: 'primary',
                    sx: {
                        ml: 2
                    }
                }],
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'wpo',
                    freeSolo: true,
                    multiple: true,
                    disableCloseOnSelect: true,
                    renderTags: function () { return null; },
                    clearText: 'Clear Selected Labour',
                    columnSize: true,
                    placeholder: 'Search job card...'
                }, {
                    type: FormItemTypes.Button,
                    name: 'More',
                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                    size: 'small',
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: '7px'
                    },
                    columnSize: 0
                }, {
                    type: FormItemTypes.List,
                    name: 'multipelJobCards',
                    columnSize: 12,
                    value: [{
                            id: 0,
                            JCNo: "JC23456789876",
                            code: '#01100320',
                            CreatedBy: 'Michael Adams'
                        }, {
                            id: 1,
                            JCNo: "JC23456789876",
                            code: '#01100320',
                            CreatedBy: 'Michael Adams'
                        }, {
                            id: 2,
                            JCNo: "JC23456789876",
                            code: '#01100320',
                            CreatedBy: 'Michael Adams'
                        }, {
                            id: 3,
                            JCNo: "JC23456789876",
                            code: '#01100320',
                            CreatedBy: 'Michael Adams'
                        }],
                    columns: [{
                            field: 'multipleJobCard',
                            flex: 1,
                            renderCell: function (_ref2) {
                                var row = _ref2.row;
                                return /*#__PURE__*/ React.createElement(Stack, {
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    height: '100%',
                                    paddingY: '12px'
                                }, /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        wordWrap: 'break-word',
                                        overflowWrap: 'break-word',
                                        whiteSpace: 'normal',
                                        overflow: 'hidden',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical'
                                    },
                                    fontWeight: 'medium'
                                }, row === null || row === void 0 ? void 0 : row.JCNo));
                            }
                        }],
                    elements: muiltipleJCWorkOrderDetailsElements
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: "WPODetails",
            label: "",
            value: null,
            element: ((_crud$WorkPurchaseOrd4 = crud[WorkPurchaseOrderKeys.WPOOrganizationModulesItemSetting]) === null || _crud$WorkPurchaseOrd4 === void 0 || (_crud$WorkPurchaseOrd4 = _crud$WorkPurchaseOrd4.data) === null || _crud$WorkPurchaseOrd4 === void 0 ? void 0 : _crud$WorkPurchaseOrd4.WPOType) === "Single JobCard" ? WPOPartDetails : MultipleJCWPOPartDetails,
            columnSize: 12
        }];
    var step3 = [{
            type: FormItemTypes.CardComponent,
            name: "",
            label: "",
            value: null,
            columnSize: 12,
            title: "Notes & attachments",
            sx: {
                borderRadius: '8px !important',
                padding: 1.5,
                '& .MuiCardHeader-root': {
                    padding: '0px 0px 20px 0px !important'
                },
                '& .MuiCardContent-root': {
                    padding: 0
                }
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "Notes & attachments",
                    label: "Notes & attachments",
                    value: null,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: "DriverName",
                            label: "Driver name"
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "DriverContactNumber",
                            label: "Driver contact number"
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "AdditionalInstructiona",
                            label: "Additional instructions"
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "GatepassNo",
                            label: "Gatepass no."
                        }, {
                            type: FormItemTypes.Attachment,
                            name: "Add attachments",
                            label: "Add attachments",
                            value: null
                        }]
                }]
        }];
    var steps = [{
            id: '0',
            label: 'General & part detail',
            elements: step1,
            containerProps: {
                paddingX: 2
            }
        }, {
            id: '1',
            label: 'Work order data',
            elements: step2,
            containerProps: {
                paddingX: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2
                }
            }
        }, {
            id: '2',
            label: 'Additional information',
            elements: step3,
            containerProps: {
                paddingX: 2
            }
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            gap: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    columnSize: 0,
                    onClick: function () { return navigate("/workPurchaseOrder"); },
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: "",
                    children: "Create work purchase order",
                    columnSize: 0,
                    variant: "h1",
                    noWrap: true
                }, mode !== "add" ? {
                    type: FormItemTypes.Custom,
                    name: "",
                    columnSize: 0,
                    element: function (props) {
                        var _props$value;
                        return /*#__PURE__*/ React.createElement(Chip, {
                            label: props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 || (_props$value = _props$value.Status) === null || _props$value === void 0 ? void 0 : _props$value.Name,
                            size: "small",
                            variant: "outlined",
                            sx: {
                                borderRadius: 2,
                                px: 1,
                                fontWeight: "bold"
                            },
                            icon: /*#__PURE__*/ React.createElement(Box, {
                                height: 8,
                                width: 8,
                                borderRadius: 10,
                                bgcolor: "gray"
                            })
                        });
                    }
                } : null, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            columnSize: 0,
                            children: "",
                            sx: {
                                color: "gray"
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 1,
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: "Quick Links",
                            disabled: isDisable,
                            columnSize: 0,
                            variant: "text",
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: "none"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: DownloadIcon,
                                alt: ""
                            }),
                            columnSize: 0,
                            disabled: isDisable,
                            variant: "outlined",
                            sx: {
                                px: "10px",
                                borderColor: "#DEE4EB",
                                opacity: isDisable ? 0.5 : "none"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: ShareIcon
                            }),
                            columnSize: 0,
                            disabled: isDisable,
                            variant: "outlined",
                            sx: {
                                px: "10px",
                                borderColor: "#DEE4EB",
                                opacity: isDisable ? 0.5 : "none"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: PrintIcon,
                                alt: ""
                            }),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: isDisable,
                            sx: {
                                px: "10px",
                                borderColor: "#DEE4EB",
                                opacity: isDisable ? 0.5 : "none"
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "100%",
                            width: "2px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: "Save",
                            columnSize: 0,
                            variant: isDisable ? "outlined" : "contained",
                            disabled: isDisable,
                            onClick: function () { return "submit"; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'tabs',
            label: "",
            value: "0",
            tabs: steps,
            valueExpr: "id",
            displayExpr: "label",
            variant: 'scrollable',
            columnSize: 12,
            sx: {
                px: 2,
                gap: 2
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: "",
                    children: "Save",
                    columnSize: 0,
                    variant: isDisable ? "outlined" : "contained",
                    disabled: isDisable,
                    onClick: function () { return "submit"; }
                }],
            columnSize: 12
        }];
    var handleOnFormClose = function () {
        if (mode == "add") {
            dispatch(showNotification({
                isOpen: true,
                message: "Stock Transfer Created Successfully",
                type: "success"
            }));
        }
        else {
            dispatch(showNotification({
                isOpen: true,
                message: "Stock Transfer Updated Successfully",
                type: "success"
            }));
        }
        navigate("/workPurchaseOrder");
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        formProps: {
            bgcolor: faintblue
        },
        getFormAPI: getstockTransferRequisition,
        getKey: StockTransferRequisitionAPIKeys.get,
        getRequest: {
            id: id
        },
        pagingAPIKey: WorkPurchaseOrderKeys.Paging,
        createKey: WorkPurchaseOrderKeys.CreateWorkPurchaseOrder,
        createFormAPI: workPurchaseOrderCreate,
        createRequest: {
            OrganizationId: UserOrganization,
            ParentOrganizationId: UserParentOrganization,
            Status: "Draft",
            DocumentDate: new Date().toISOString(),
            TotalAmount: 10,
            DriverName: null,
            DriverMobileNo: null,
            GatePass: null,
            Attachments: []
        },
        updateRequest: {
            OrganizationId: UserOrganization,
            ParentOrganizationId: UserParentOrganization,
            Status: "Draft",
            DocumentDate: new Date().toISOString(),
            TotalAmount: 10,
            DriverName: null,
            DriverMobileNo: null,
            GatePass: null,
            Attachments: []
        },
        updateFormAPI: workPurchaseOrderCreate,
        updateKey: WorkPurchaseOrderKeys.Update,
        onClose: handleOnFormClose
    }));
};
